import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PaymentDatePage } from './payment-date.page';

const routes: Routes = [
  {
    path: '',
    component: PaymentDatePage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class PaymentDatePageRoutingModule {}
